<template>
  <div class="page">
    <header-banner :list="banners" />
    <header-notice :list="noticeList" />
    <header-title :title="'宗族介绍: ' + detail.info" :cover="detail.mainImg" />

    <iain-gap height="10" bgColor="#EEEEEE" />

    <div class="info">
      <div class="prepend">
        <van-icon class="icon" name="setting" color="#606266"/>
        <span>组织架构: 共{{detail.teamStructureNum}}人</span>
      </div>
      <div class="append">
        <span>群主:</span>
        <iain-image-domain class="avatar" w="40" h="40" r="6" :src="detail.teamLeaderAvatar" />
        <span class="name">{{ detail.teamLeaderNickname }}</span>
        <van-icon name="arrow"/>
      </div>
    </div>

    <iain-gap height="10" bgColor="#EEEEEE" />

    <div class="card">
      <iain-title title="杰出人物" />
      <div class="content">
        <user-info-item v-for="(item, index) in outstanding" :key="index" :name="item.nickname" :avatar="item.avatar" />

      </div>
    </div>

    <iain-gap height="10" bgColor="#EEEEEE" />

    <div class="card">
      <iain-title title="善长名人" />
      <div class="content">
        <user-info-item v-for="(item, index) in famous" :key="index" :name="item.nickname" :avatar="item.avatar" />
      </div>
    </div>

    <iain-gap height="10" bgColor="#EEEEEE" />

    <div class="card">
      <iain-title title="资源">
        <div slot="append" class="title-append">
          <span>更多资源</span>
          <van-icon name="arrow"/>
        </div>
      </iain-title>

      <resource :list="resource"/>
    </div>

    <iain-gap height="10" bgColor="#EEEEEE" />

    <div class="card">
      <iain-title title="个人赞助" />
      <div class="content">
        <user-info-item v-for="(item, index) in sponsor" :key="index" :name="item.nickname" :avatar="item.avatar" />
      </div>
    </div>

    <download :scheme="`juqin://?type=team_home_detail&teamId=` + teamId" />
  </div>
</template>

<script>
import HeaderBanner from './components/HeaderBanner'
import HeaderNotice from './components/HeaderNotice'
import HeaderTitle from './components/HeaderTitle'
import Resource from './components/Resource'

import UserInfoItem from './components/UserInfoItem'

export default {
  name: 'TeamDetail',
  components: {
    HeaderBanner,
    HeaderNotice,
    HeaderTitle,
    Resource,
    UserInfoItem
  },
  data() {
    return {
      teamId: '',
      detail: {},
      banners: [],
      resource:[],
      noticeList:[],
    }
  },
  computed: {
    famous() {
      return this.detail.famous ? this.detail.famous || [] : []
    },
    outstanding() {
      return this.detail.outstanding ? this.detail.outstanding || [] : []
    },
    sponsor() {
      return this.detail.sponsor ? this.detail.sponsor || [] : []
    }
  },
  mounted() {
    this.teamId = this.$route.query.id
    this.init()

    document.title = this.$route.query.title || '群主页'
  },
  methods: {
    async init() {
      const loading = this.$toast.loading({ message: '加载中' })
      await Promise.all([this.getDetail()])
      await Promise.all([this.getNewsTopList()])
      await Promise.all([this.getMonthDonateLogList()])
      loading.clear()
    },
    async getMonthDonateLogList() {
      const response = await this.$request.api.get({ url: this.$api.monthDonateLogListUrl + this.teamId })
      const { success, message, code, data } = response
      if (success && code === 200) {
        if (data.length > 0) {
          this.noticeList = data;
        }else {
          this.noticeList = ['暂无新的公告'];
        }
      } else {
        this.$toast.fail(message || '获取详情失败')
      }
    },
    async getDetail() {
      const response = await this.$request.api.get({ url: this.$api.teamDetailUrl + this.teamId })
      const { success, message, code, data } = response

      if (success && code === 200) {
        this.detail = data || {}
        if (this.detail.imgList) {
          this.banners = this.detail.imgList.split(',').map(path => {
            return { title: path, logo: path }
          })
        }
      } else {
        this.$toast.fail(message || '获取详情失败')
      }
    },

    async getNewsTopList() {
      const response = await this.$request.api.get({ url: this.$api.newsTopUrl + this.teamId })
      const { success, message, code, data } = response

      if (success && code === 200) {
        data.forEach(ele => {
          this.resource.push({
            title: ele.title,
            image: this.$FILE_PATH + ele.imgUrl
          });
        })
      } else {
        this.$toast.fail(message || '获取详情失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  height: 100px;

  .prepend,
  .append {
    display: flex;
    align-items: center;
  }

  .icon {
    font-size: 30px;
    margin-right: 15px;
  }

  .avatar {
    margin: 0 15px;
  }
}

.card {
  padding: 15px 30px;
  background-color: #ffffff;

  .title-append {
    display: flex;
    align-items: center;
  }

  .content {
    padding-top: 15px;
    display: flex;
    overflow: auto;
  }
}
</style>
